var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"firstTimeUserPopUp"},on:{"click":function($event){return _vm.hideFTU()}}},[_c('img',{staticClass:"firstTimeImg",attrs:{"src":"https://www.csub.edu/selfservice/images/myCSUB_FirstTimeUser.png","alt":"myCSUB First time user guide","longdesc":"http://www.csub.edu/its/new/index.html"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }